// extracted by mini-css-extract-plugin
export var chip = "_cl-0";
export var filterDropdown = "_cl-5";
export var filterItem = "_cl-6";
export var icon = "_cl-1";
export var removeButton = "_cl-3";
export var removeIcon = "_cl-4";
export var separator = "_cl-2";